import { SettingsManager } from "@viamap/viamap2-common";
import { ESInterface } from "src/compentsModus/ESInterface";
import { MapitUtils } from "src/managers/MapitUtils";


export class ActionTracker {
   private static session: string = MapitUtils.getNewUuid();

   private static CustomerID: string = "";
   private static cognitoID: string = "";
   private static UserID: string = "";
   private static ESInterface: ESInterface | null = null;

   public static attachUserInfo(cognitoID: string, userID: string, customerID: string, userSession?: any) {
      (ActionTracker as any).cognitoID = cognitoID;
      (ActionTracker as any).UserID = userID;
      (ActionTracker as any).CustomerID = customerID;
      let es = SettingsManager.getSystemSetting("actionTrackerIndex", null, true) || "";
      (ActionTracker as any).ESInterface = new ESInterface(es);
   }

   private static hasRequiredUserInfo(): boolean {
      return (ActionTracker.cognitoID !== "" &&
         ActionTracker.UserID !== "" &&
         ActionTracker.CustomerID !== ""
      );
   }

   static async track(type: string, sub: string, action: string, details: Partial<Details> = {}) {
      if (!ActionTracker.hasRequiredUserInfo()) {
         return;
      }

      let body = {
         sessionID: ActionTracker.session,
         cognitoID: ActionTracker.cognitoID,
         UserID: ActionTracker.UserID,
         CustomerID: ActionTracker.CustomerID,
         timestamp: new Date().toISOString(),

         application: "Mapit",
         type: type,
         sub: sub,
         action: action,
         ...details
      }
      if (ActionTracker.ESInterface) {
         ActionTracker.ESInterface.updateDocument("", body).then(response => { if (response.ok) console.log('Stats sent successfully') }).catch(error => console.error('Error sending stats:', error));
      }
   }
}

type Details = {
   //Common
   coord: [number, number];
   screenX: number;
   screenY: number;
   href: string;

   tabName: string;

   //Map
   zoom: number;
   pitch: number;
   center: [number, number];
   rotation: number;

   //FeatureLayer
   layerID: string;
   layerType: string;

   //CustomLayer
   groupID: string;
   groupLayers: string[];

   //FileImport
   fileName: string;
   fileType: string;
   fileSize: number;

   // PoiTypes
   poiTypes: string[];

   // Oblique
   imgDirection: string;
   imgZoom: number;
   imgYear: string;

   // Plot
   quality: string;

   // DrawingTool
   mode: string;

   //Error
   ErrorLocation: string;
   ErrorMessage: string;
   StackTrace: string;
   ComponentStack: string;

   //RightPane
   rightPaneModus: string;

   //Window
   windowId: string;
}